'use client';

import { DividerSection as UIDividerSection } from '@stereoagency/ui';

export default function ImageGallerySection() {
  return <UIDividerSection />;
}
